import { Constants } from '@/common/Constants';
import {
	WaterMetersApi,
	WaterMonitorsApi,
	WaterTanksApi,
	WaterTotalizerCorrectionDynamoItem,
} from '@/api';
import { ApiUtils } from '@/common/ApiUtils';
import { AxiosResponse } from 'axios';

export class WaterEntityService {
	private readonly waterMetersApi = new WaterMetersApi();
	private readonly waterTanksApi = new WaterTanksApi();
	private readonly waterMonitorsApi = new WaterMonitorsApi();

	private readonly getEntityGraphDataApiCall!: (
		entityId: number,
		nDays?: number,
		offset?: string,
	) => Promise<AxiosResponse>;
	private readonly getEntityCurrentStateApiCall!: (entityId: number) => Promise<AxiosResponse>;

	constructor(private entityType: string, private entityId: number) {
		switch (this.entityType) {
			case Constants.ENTITY_TYPE_WATER_METER:
				this.getEntityGraphDataApiCall = this.waterMetersApi.getWaterMeterGraphData;
				this.getEntityCurrentStateApiCall = this.waterMetersApi.getWaterMeterCurrentState;
				break;
			case Constants.ENTITY_TYPE_WATER_TANK:
				this.getEntityGraphDataApiCall = this.waterTanksApi.getWaterTankGraphData;
				this.getEntityCurrentStateApiCall = this.waterTanksApi.getWaterTankCurrentState;
				break;
			case Constants.ENTITY_TYPE_WATER_MONITOR:
				this.getEntityGraphDataApiCall = this.waterMonitorsApi.getWaterMonitorGraphData;
				this.getEntityCurrentStateApiCall = this.waterMonitorsApi.getWaterMonitorCurrentState;
				break;
			default:
				throw 'Entity type must be one of water_meters, water_tanks, or water_monitors';
		}
	}

	public async getGraphData(
		days: number,
		offset: number,
	): Promise<{
		data?: any;
		error?: string;
	}> {
		try {
			let { data } = await this.getEntityGraphDataApiCall(this.entityId, days, `${offset}`);
			return { data: data.data };
		} catch (e) {
			const { errorMessage } = ApiUtils.handleApiError(
				e,
				'Unknown error loading water meter graph data',
			);
			return { error: errorMessage };
		}
	}

	public async getCurrentState(): Promise<{
		data?: any;
		error?: string;
	}> {
		try {
			let { data } = await this.getEntityCurrentStateApiCall(this.entityId);
			return { data: data.data };
		} catch (e) {
			const { errorMessage } = ApiUtils.handleApiError(
				e,
				'Unknown error loading water meter graph data',
			);
			return { error: errorMessage };
		}
	}
}
